export {default as Navbar} from './Navbar/Navbar'
export {default as SocialMedia} from './SocialMedia'
export {default as NavigationDots} from './NavigationDots'


const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']

// a function returns the time in HH:MM:SS format
function getTime () {
    const date = new Date()
    const time = {}

    time.hh = date.getHours()
    time.mm = date.getMinutes()
    time.ss = date.getSeconds()
    time.day = date.getDate()
    time.month = months[date.getMonth()]
    time.year = date.getFullYear()

    return time
}

export {getTime}